import {useEffect, useRef} from 'react';

export const usePrevious = <T>(value: T): T => {

    const refValue = useRef<T>(value);

    useEffect(() => {
        refValue.current = value;
    }, [value]);

    return refValue.current;
};
